import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=1ff02e06&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
import style0 from "./Top.vue?vue&type=style&index=0&id=1ff02e06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff02e06",
  null
  
)

export default component.exports